// extracted by mini-css-extract-plugin
export default {"button":"LinkButton_button__dCOK7"};